// The wallet management screen serves three work queues. They are separate
// ROUTES rather than one route with a query param, because everything that makes
// navigation legible in this app keys off `route.path`: the sidebar's active
// highlight (`route.path.startsWith(item.to)`) and the top-nav breadcrumb map are
// both path-only. Behind a query string all three queues shared one path, so no
// menu item lit up and every one of them displayed the same heading.
export const WALLET_MANAGEMENT_ROUTE = {
  ALL: 'wallets.cryptoWallets.walletManagement',
  TRUSTLINE_APPROVALS: 'wallets.cryptoWallets.trustlineApprovals',
  FAILED_ON_CHAIN: 'wallets.cryptoWallets.failedOnChain',
  DETAIL: 'wallets.cryptoWallets.walletManagementDetail',
} as const

export const WALLET_MANAGEMENT_PATH = {
  ALL: '/wallets/crypto-wallets/management',
  TRUSTLINE_APPROVALS: '/wallets/crypto-wallets/trustline-approvals',
  FAILED_ON_CHAIN: '/wallets/crypto-wallets/failed-onchain',
} as const

// Heading per queue. Empty for the unfiltered table, whose page title already
// says what it is.
export const WALLET_MANAGEMENT_QUEUE_HEADING: Record<string, string> = {
  [WALLET_MANAGEMENT_ROUTE.TRUSTLINE_APPROVALS]: 'Orders waiting on a trustline',
  [WALLET_MANAGEMENT_ROUTE.FAILED_ON_CHAIN]: 'Trustlines the ledger rejected',
}
